import { render, staticRenderFns } from "./ConversationBasicFilter.vue?vue&type=template&id=a50b97a0&scoped=true&"
import script from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
export * from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBasicFilter.vue?vue&type=style&index=0&id=a50b97a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50b97a0",
  null
  
)

export default component.exports